import type { SlotsManagementStore } from './interfaces'

export const actions = {
  setSaving (this: SlotsManagementStore, payload: SlotsManagementStore['saving']): void {
    this.saving = payload
  },
  setDayTabId (this: SlotsManagementStore, payload: SlotsManagementStore['dayTabId']): void {
    this.dayTabId = payload
  },
  setBookingDays (this: SlotsManagementStore, payload: SlotsManagementStore['bookingDays']): void {
    this.bookingDays = payload
  },
  setSalesQueueDays (this: SlotsManagementStore, payload: SlotsManagementStore['salesQueueDays']): void {
    this.salesQueueDays = payload
  },
}
